// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { foodSensoryAnalystId } from './FoodSensoryAnalyst';
import { foodSensorySessionSampleId } from './FoodSensorySessionSample';
import { foodSensoryRoundQuestionId } from './FoodSensoryRoundQuestion';
import { z } from 'zod';
export const foodSensoryResponseId = (z.number());
export const foodSensoryResponse = z.object({
    id: foodSensoryResponseId,
    analyst_id: foodSensoryAnalystId,
    sample_id: foodSensorySessionSampleId.nullable(),
    value_text: z.string().nullable(),
    value_number: z.number().nullable(),
    value_json: z.unknown().nullable(),
    answered_at: z.date().nullable(),
    question_id: foodSensoryRoundQuestionId,
    quote_shown: z.boolean().nullable(),
});
export const foodSensoryResponseInitializer = z.object({
    id: foodSensoryResponseId.optional(),
    analyst_id: foodSensoryAnalystId,
    sample_id: foodSensorySessionSampleId.optional().nullable(),
    value_text: z.string().optional().nullable(),
    value_number: z.number().optional().nullable(),
    value_json: z.unknown().optional().nullable(),
    answered_at: z.date().optional().nullable(),
    question_id: foodSensoryRoundQuestionId,
    quote_shown: z.boolean().optional().nullable(),
});
export const foodSensoryResponseMutator = z.object({
    id: foodSensoryResponseId.optional(),
    analyst_id: foodSensoryAnalystId.optional(),
    sample_id: foodSensorySessionSampleId.optional().nullable(),
    value_text: z.string().optional().nullable(),
    value_number: z.number().optional().nullable(),
    value_json: z.unknown().optional().nullable(),
    answered_at: z.date().optional().nullable(),
    question_id: foodSensoryRoundQuestionId.optional(),
    quote_shown: z.boolean().optional().nullable(),
});
//# sourceMappingURL=FoodSensoryResponse.js.map